<template>
  <div id="app">
    <!-- <transition name="fade">
      <router-view />
    </transition> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    this.$store.dispatch("lineIconList");
    this.$store.dispatch("getWebInfo");
        this.$store.dispatch("getTour");

    //模拟登录测试
    this.$store.dispatch("getMember");
    // this.$store.commit(
    //   "saveToken",
    //   // "eyJhbGciOiJIUzI1NiJ9.eyJuaWNrX25hbWUiOiJEQVNEQTEyMSIsInVpZCI6IkRTU0ZBV0RXQURBUy4uLiIsImV4cCI6MTk1NjA4OTY2MSwidXNlcl9uYW1lIjoiYWRtaW4iLCJzdWIiOiJ7XCJ1c2VybmFtZVwiOlwi5pyq6IezXCIsXCJoZWFkUGljXCI6XCJodHRwOi8vd3d3LjE3Nzhody5jb20vY21zL2ltYWdlLzIwMjAvMDcvMjcvYjc3MTZhZWItZWMzNi00MmVhLTg5MTUtZWRjYmZhNzllMWU0LmpwZ1wiLFwiaWRcIjpcIjg5NjhcIn0iLCJqdGkiOiJqd3QiLCJpYXQiOjE1OTYwODk2NjF9.xBW1QmvyWLvnwWfddDp1nAtgSgBeu_9KbEKm-kiPTXc"
    //   "eyJhbGciOiJIUzI1NiJ9.eyJuaWNrX25hbWUiOiJEQVNEQTEyMSIsInVpZCI6IkRTU0ZBV0RXQURBUy4uLiIsImV4cCI6MTk1NDI2MzMyOSwidXNlcl9uYW1lIjoiYWRtaW4iLCJzdWIiOiJ7XCJ1c2VybmFtZVwiOlwi6bqm5Y2O5pmuXCIsXCJoZWFkUGljXCI6XCJodHRwOi8vdGhpcmR3eC5xbG9nby5jbi9tbW9wZW4vdmlfMzIvUTBqNFR3R1RmVEt6SXZ5QjZpYVVCZGc0WGp5aHo4UWpKZXhSc2VUbmMyZmJPc05XN0ZveEpUQzhwdHBVTXVUeVZhMjNpYndtZHBVNFBOeE4weGtoT0lOQS8xMzJcIixcImlkXCI6XCI4OTY2XCJ9IiwianRpIjoiand0IiwiaWF0IjoxNTk0MjYzMzI5fQ.WvHliI5uPQ5WVKDZluKtCHIvC__SOUhYzGTGyqtc9rc"
    // );  
    }
};
</script>

<style>
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  font-family: "PingFangSC-Light", "Helvetica Neue", "Hiragino Sansgb", "Arial",
    "Microsoft Yahei", "Microsoft Yahei ui", "Simsun", "Sans-serif";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1200px;
  padding-top: 60px;
}
img {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
}
.el-message {
  top: 50% !important;
  min-width: 240px !important;
}
.pagination {
  margin-top: 15px;
  text-align: center;
}
input {
  color: #666 !important;
}
body,
p,
div,
h1,
h2,
h3,
h4,
h5,
h6,
* {
  padding: 0;
  margin: 0;
  /* font-size: 14px; */
}

ul {
  height: auto !important;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei", "HanHei SC",
    "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB", "微软雅黑",
    STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif !important;
}

input {
  -webkit-appearance: none !important;
  outline: none !important;
}

ul li {
  list-style: none;
}

a {
  text-decoration: none;
  color: #333;
}
.container {
  width: 84%;
  margin: 0 auto;
  /* padding: 0 100px; */
  box-sizing: border-box;
  position: relative;
}
.here-wrapper {
  display: flex;
  font-size: 14px;
  line-height: 50px;
}
.here-item {
  margin-right: 3px;
}
.here-item i {
}
.wrapper-title {
  height: 80px;
  line-height: 80px;
  border-left: 3px solid #106e98;
  display: inline;
  padding-left: 10px;
  color: #106e98;
  font-size: 30px;
  padding-right: 10px;
  border-right: 3px solid #106e98;
  position: relative;
}
.wrapper-title::before {
  content: "";
  width: 3px;
  background: rgba(16, 110, 152, 0.6);
  height: 20px;
  position: absolute;
  left: -15px;
  top: 5px;
}
.wrapper-title::after {
  content: "";
  width: 3px;
  background: rgba(16, 110, 152, 0.6);
  height: 20px;
  position: absolute;
  right: -15px;
  top: 5px;
}

table {
  border: 0;
  border-spacing: 0;
  border-collapse: collapse;
}

/* .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue